module.exports = __webpack_public_path__ + "img/persona-fr.a88476e8.png";